import { render, staticRenderFns } from "./admin-nav.vue?vue&type=template&id=11e019b0"
import script from "./admin-nav.vue?vue&type=script&lang=js"
export * from "./admin-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports